import { Component, Input } from '@angular/core';
import { ERRORTYPE, filterErrors } from './form.objects';
import { BaseComponent } from '../common/baseComponent/base.component';

@Component({
  selector: 'formControlError',
  templateUrl: 'formControl-error.template.html'
})
export class FormControlErrorComponent extends BaseComponent {
  public ERRORTYPE = ERRORTYPE;
  public filterErrors = filterErrors;

  @Input()
  public object: any;

  ngOnDestroy(): void {
    this.object = null;
    super.ngOnDestroy();
  }


}
